export default __webpack_public_path__ + "static/media/hm_metafeat.83a19ac1.jpg";